import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import {
	IndicacaoApiResponse,
	IndicacaoFiltros,
	IndicacaoSolicitacaoLista,
} from './indicacao.types';

export const getIndicacaoSolicitacoes = async (filtros?: IndicacaoFiltros) => {
	try {
		const response = await BaseClient.get<IndicacaoApiResponse<IndicacaoSolicitacaoLista[]>>(
			'v2/Indicacao/Solicitacoes',
			{
				params: {
					data_inicio: filtros?.data_inicio || undefined,
					data_fim: filtros?.data_fim || undefined,
					id_usuario: filtros?.id_usuario || undefined,
				},
			}
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoSolicitacaoLista[]>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
